import React from "react";
var __jsx = React.createElement;
import { Link } from "react-router-dom";
import { useTranslation } from "@i18n";
import Container from "@/components/sharedComponents/container/Container";
import ResponsivePostGrid from "@/components/shared/Grid/ResponsivePostGrid";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import useIsMobile from "@hooks/useIsMobile";
var UsedCarsUnder30KSection = function UsedCarsUnder30KSection() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var _ref = useFullPageData() || {},
    usedCarsUnder30K = _ref.usedCarsUnder30K;
  var displayedPosts = usedCarsUnder30K || [];
  var isMobile = useIsMobile();
  var ctaLink = "/filters?condition_id=0&sellingprice_from=2000&sellingprice_to=30000";
  if (!displayedPosts.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("section", {
    className: "py-4 md:py-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex mb-6"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary text-lg  lg:text-2xl font-bold"
  }, tShort("used_cars_under_30k/title"))), /*#__PURE__*/React.createElement(ResponsivePostGrid, {
    posts: displayedPosts,
    ctaLink: ctaLink,
    sectionType: "listing"
  }), !isMobile && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center mt-6 mx-auto w-[250px]"
  }, /*#__PURE__*/React.createElement(Link, {
    to: ctaLink,
    className: "rounded w-full bg-[#FE561C] px-6 py-3 text-center text-white text-sm font-bold leading-4 outline-none border-none cursor-pointer hover:text-white hover:bg-[#e54a19] transition-colors"
  }, t("اعرض الكل", {
    ns: "web_common"
  })))));
};
export default UsedCarsUnder30KSection;